"use strict";

/**
* Sets the center of the given Google Map coordinates
  @param {number} lat - the latitude of the center
* @param {number} lng - the longitude of the center
*/
function setCenter(lat, lng) {
    const latlng     = new google.maps.LatLng(lat, lng);
    const mapOptions = {
        scrollwheel : false,
        zoom        : 14,
        center      : latlng,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };

    window.googleMap    = new google.maps.Map($(".map-canvas")[0], mapOptions);
    const bounds        = new google.maps.LatLngBounds();
    const selectedStore = window.googleMapLocations.find((store) => {
        var currentStore = new google.maps.LatLng(store.latitude, store.longitude);

        return currentStore.equals(latlng);
    });

    const storeLocation = new google.maps.LatLng(selectedStore.latitude, selectedStore.longitude);
    const marker        = new google.maps.Marker({
        animation: google.maps.Animation.DROP,
        position : storeLocation,
        map      : window.googleMap,
    });

    if (selectedStore.infoWindowHtml) {
        const infowindow = new google.maps.InfoWindow({
            content: selectedStore.infoWindowHtml
        });

        marker.addListener("click", function () {
            infowindow.open(window.googleMap, marker);
        });

        infowindow.open(window.googleMap, marker);
    }

    // Create a minimum bound based on a set of storeLocations
    bounds.extend(marker.position);

    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    window.googleMap.setCenter(bounds.getCenter());
    window.googleMap.setZoom(14);
}

module.exports = {
    setCenter : setCenter
};
